"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailLogsResponseSchema = exports.EmailLogsQuerySchema = exports.RecipientEmailHistorySchema = exports.EmailLogEntrySchema = exports.SentDocumentSchema = exports.FormattedSesEmailEventSchema = exports.EmailPreviewResponseSchema = exports.EmailPreviewQuerySchema = exports.EmailPreviewSchema = exports.EmailQuoteDocumentPreviewSchema = exports.EmailPreviewAttachmentSchema = void 0;
const zod_1 = require("zod");
exports.EmailPreviewAttachmentSchema = zod_1.z.object({
    url: zod_1.z.string(),
    quoteNumber: zod_1.z.number(),
    quoteName: zod_1.z.string(),
});
exports.EmailQuoteDocumentPreviewSchema = zod_1.z.object({
    url: zod_1.z.string(),
    label: zod_1.z.string(),
    isPdf: zod_1.z.boolean(),
});
exports.EmailPreviewSchema = zod_1.z.object({
    quoteId: zod_1.z.string().optional(),
    customers: zod_1.z.array(zod_1.z.object({
        id: zod_1.z.string(),
        firstName: zod_1.z.string(),
        lastName: zod_1.z.string(),
        email: zod_1.z.union([zod_1.z.string(), zod_1.z.null()]),
    })),
    subject: zod_1.z.string(),
    message: zod_1.z.string(),
    attachmentUrl: zod_1.z.string(),
    additionalAttachments: zod_1.z.array(exports.EmailPreviewAttachmentSchema).optional(),
    documentPreviews: zod_1.z.array(exports.EmailQuoteDocumentPreviewSchema).optional(),
});
exports.EmailPreviewQuerySchema = zod_1.z.object({
    quoteId: zod_1.z.string().optional(),
    quoteIds: zod_1.z.string().optional(),
    invoiceId: zod_1.z.string().optional(),
});
exports.EmailPreviewResponseSchema = zod_1.z.object({
    data: exports.EmailPreviewSchema,
});
exports.FormattedSesEmailEventSchema = zod_1.z.object({
    type: zod_1.z.enum(['Send', 'Delivery', 'Bounce', 'Open']),
    timestamp: zod_1.z.string(),
    messageId: zod_1.z.string(),
    stringlineEmailId: zod_1.z.string().optional(),
    from: zod_1.z.string(),
    to: zod_1.z.array(zod_1.z.string()),
    status: zod_1.z.enum(['Sent', 'Delivered', 'Bounced', 'Opened']),
    reason: zod_1.z.string().optional(),
    ipAddress: zod_1.z.string().optional(),
    userAgent: zod_1.z.string().optional(),
});
exports.SentDocumentSchema = zod_1.z.object({
    id: zod_1.z.string(),
    fileName: zod_1.z.string(),
});
exports.EmailLogEntrySchema = zod_1.z.object({
    id: zod_1.z.string(),
    quoteId: zod_1.z.string().optional(),
    invoiceId: zod_1.z.string().optional(),
    toEmail: zod_1.z.string(),
    sentAt: zod_1.z.date(),
    events: zod_1.z.array(exports.FormattedSesEmailEventSchema),
    documents: zod_1.z.array(exports.SentDocumentSchema),
    linkedQuotes: zod_1.z
        .array(zod_1.z.object({
        id: zod_1.z.string(),
        number: zod_1.z.number(),
        name: zod_1.z.string(),
    }))
        .optional(),
});
exports.RecipientEmailHistorySchema = zod_1.z.object({
    recipientEmail: zod_1.z.string(),
    logs: zod_1.z.array(exports.EmailLogEntrySchema),
});
exports.EmailLogsQuerySchema = zod_1.z.object({
    quoteId: zod_1.z.string().optional(),
    invoiceId: zod_1.z.string().optional(),
});
exports.EmailLogsResponseSchema = zod_1.z.object({
    data: zod_1.z.array(exports.RecipientEmailHistorySchema),
});
